<template>
  <form action="#" class="form" data-gw-tab="support" data-gw-tab-grp="form">
    <div class="field field_grp field_mb">
      <div class="field__desc">
        <div class="field__ico">
          <img src="@/assets/images/icons/ico__flag.png" alt="" />
        </div>
        <div class="field__title">{{ $t('support.choose') }}</div>
      </div>
      <select class="tt-uppercase" @change="service_obj_change" v-model="service">
        <template v-for="(service, index) in services" :key="index">
          <option :value="service.value">{{ service.name }}</option>
        </template>
      </select>
    </div>
    <!-- END  field -->

    <div class="form__btn-box">
      <template v-if="this.service_obj.is_link">
        <a :href="this.service_obj.link" target="_blank" class="button">
          <span class="button__content">{{ $t('support.continue') }}</span>
        </a>
      </template>
      <template v-else>
        <router-link :to="{ path: '/' + service }" class="button">
          <span class="button__content">{{ $t('support.continue') }}</span>
        </router-link>
      </template>
    </div>
  </form>
</template>

<script>
// import { __config } from "@/assets/js/config";

export default {
  name: 'Support',
  data() {
    return {
      service: 'info',
      service_obj: {
        value: 'info',
        name: this.$t('support.information'),
        is_link: true,
        link: this.$store.getters.get_servers[this.$store.getters.get_default_server - 1].desc_link,
      },
      services: [
        { value: 'changePassword', name: this.$t('support.change_password'), is_link: false },
        {
          value: 'restorePassword',
          name: this.$t('support.restore_password'),
          is_link: false,
        },
        { value: 'changeEmail', name: this.$t('support.change_email'), is_link: false },
        { value: 'unbind', name: this.$t('support.unbind'), is_link: false },
        {
          value: 'restoreUsername',
          name: this.$t('support.restore_id'),
          is_link: false,
        },
        { value: 'vote', name: this.$t('support.vote'), is_link: false },
        { value: 'contacts', name: this.$t('support.contacts'), is_link: false },
        // TODO: Create links for those 2 menus
        {
          value: 'info',
          name: this.$t('support.information'),
          is_link: true,
          link:
            this.$store.getters.get_servers[this.$store.getters.get_default_server - 1].desc_link ||
            '',
        },
        {
          value: 'faq',
          name: this.$t('support.faq'),
          is_link: true,
          link: 'https://forum.la2dream.com/forum/5-faq/',
        },
      ],
    };
  },
  methods: {
    service_obj_change() {
      this.service_obj =
        this.services[this.services.findIndex(item => item.value === this.service)];
    },
  },
};
</script>

<style scoped></style>
